import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import {
  Box, IconButton, Paper, Typography,
} from '@mui/material';
import { ChipField, RecordContextProvider } from 'react-admin';

export default function DraggableAlbumRow({
  id,
  position,
  title,
  cover,
  releaseYear,
  artistName,
}: {
  id: string;
  position: number;
  title: string;
  cover?: string;
  releaseYear: number | undefined;
  artistName: string;
}): JSX.Element {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  return (
    <Paper
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.7 : 1,
        cursor: isDragging ? 'grabbing' : 'grab',
      }}
      sx={{
        mb: 1,
        display: 'flex',
        alignItems: 'center',
        borderRadius: 1,
        overflow: 'hidden',
        boxShadow: isDragging ? 3 : 1,
      }}
    >
      <Box
        sx={{
          flex: '0 0 64px',
          px: 2,
          py: 1,
          textAlign: 'center',
          fontWeight: 600,
        }}
      >
        {position}
      </Box>

      <Box
        sx={{
          flex: '0 0 72px',
          px: 2,
          py: 1,
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Box
          component='img'
          src={cover}
          alt=''
          sx={{
            width: 48,
            height: 48,
            objectFit: 'cover',
            borderRadius: 1,
            border: '1px solid',
            borderColor: 'divider',
          }}
        />
      </Box>

      <Typography
        sx={{ flex: 2, px: 2, py: 1 }} noWrap
        title={title}
      >
        {title}
      </Typography>

      <Box sx={{ flex: 2, px: 2, py: 1 }}>
        <RecordContextProvider value={{ id, artistName }}>
          <ChipField source='artistName' size='small' />
        </RecordContextProvider>
      </Box>

      <Typography sx={{
        flex: 1, px: 2, py: 1, textAlign: 'center',
      }}
      >
        {releaseYear}
      </Typography>

      <Box
        sx={{
          flex: '0 0 48px',
          px: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <IconButton
          size='small'
          disableRipple
          disableFocusRipple
          title='Drag to reorder'
        >
          <DragIndicatorIcon />
        </IconButton>
      </Box>
    </Paper>
  );
}
